import { useState, useEffect } from 'react';
import { isDebugMode } from '../services/debugService';
import mediaManager from '../utils/mediaManager';

const MediaStatusIndicator = () => {
  const [status, setStatus] = useState(mediaManager.getStatus());

  useEffect(() => {
    const handleChange = (event) => {
      setStatus(event.detail);
    };

    mediaManager.on('player-changed', handleChange);

    return () => {
      mediaManager.off('player-changed', handleChange);
    };
  }, []);

  // Only show in debug mode
  if (!isDebugMode) return null;

  const activePlayers = status.players.filter(player => player.isPlaying);

  return (
    <div className="fixed top-20 right-4 z-40 bg-yellow-500 text-black px-3 py-2 rounded-lg shadow-lg text-xs max-w-xs">
      <div className="font-bold mb-1">🎵 Media Debug Info</div>
      <div>Active: {status.activePlayer || 'None'}</div>
      <div>Playing: {activePlayers.length}</div>
      <div>Players: {status.playerCount}</div>
      <div className="mt-1 space-y-1">
        {status.players.map((player) => (
          <div key={player.id} className={`text-xs ${player.isPlaying ? 'font-bold' : 'opacity-60'}`}>
            {player.isPlaying ? '▶️' : '⏸️'} {player.id} ({player.type})
          </div>
        ))}
      </div>
    </div>
  );
};

export default MediaStatusIndicator;
